import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { info } from 'console';

@Component({
  selector: 'app-list-search',
  templateUrl: './list-search.component.html',
  styleUrls: ['./list-search.component.scss']
})
export class ListSearchComponent implements OnInit {

  @Output() searchFired = new EventEmitter<string>();
  @Output() searchComplete = new EventEmitter<string>();
  @Input() placeholder: string = null;
  @Input() tallClass: string = '';

  constructor() { }

  ngOnInit(): void {
  }

  search(text:string, complete:boolean){
    this.searchFired.emit(text);
    if(complete){
      this.searchComplete.emit(text);
    }
  }

}
